import { render, staticRenderFns } from "./footbox.vue?vue&type=template&id=465d6bfe&scoped=true"
import script from "./footbox.vue?vue&type=script&lang=js"
export * from "./footbox.vue?vue&type=script&lang=js"
import style0 from "./footbox.vue?vue&type=style&index=0&id=465d6bfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465d6bfe",
  null
  
)

export default component.exports